/* 楼盘字典 */
<template>
  <div>
    <div class="warpper_top">
      <h1 class="warpper_top_title">楼盘字典</h1>
    </div>
    <div class="disFlex warpper_con">
      <div class="item_page page_district">
        <district
          :dis-list="districtList"
          @queryNewDistrict="queryDistrict"
          @districtIdEvent="districtIdHandle"
        ></district>
      </div>
      <div class="item_page page_business_district">
        <business-district
          :business-dis-list="businessDisList"
          :district-id="districtId"
          @queryBusinessDistrictEvent="queryBusinessDistrict"
          @businessDisIdEvent="businessDisIdHandle"
        ></business-district>
      </div>
      <div class="item_page page_street">
        <street
          :street-list="streetList"
          :business-dis-list="businessDisList"
          :business-district-id="businessDisId"
          @queryStreetEvent="queryStreet"
          @streetIdEvent="streetIdHandle"
        ></street>
      </div>
    </div>
  </div>
</template>

<script>
// import { districtList } from '@/api/setting/district'
import { sysList } from '@/api/setting/sys'
import { areaList } from '@/api/setting/area'
import { businessDistrictList } from '@/api/setting/businessdistrict'
import { streetList } from '@/api/setting/street'

import storage from 'store'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { tableMixin } from '@/store/table-mixin'
import District from './District'
import BusinessDistrict from './BusinessDistrict'
import Street from './Street'
import Community from './Community'

export default {
  name: 'Housesdict',
  components: {
    District,
    BusinessDistrict,
    Street,
    Community
  },
  mixins: [tableMixin],
  data () {
    return {
      districtList: [],
      queryDisParam: {
        districtFullName: undefined, // 区域全称
        districtShortName: undefined // 区域简称
      },
      districtId: undefined,

       queryArea: {
        areaName: undefined, //	名称
        level: 3, // 等级（1：省 2：市 3：区）
        parentId: undefined //	父类ID
      },

      businessDisList: [], // 商圈列表
      queryBusinessDisParam: {
        businessDistrictName: undefined, // 商圈名称
        districtId: undefined // 区域ID
      },
      businessDisId: undefined,

      streetList: [], // 街道列表
      queryStreetParam: {
        businessDistrictId: undefined, //	商圈ID
        streetFullName: undefined, // 街道全称
        streetShortName: undefined // 街道简称
      },
      streetId: undefined,

      headers: {
        Authorization: 'Bearer ' + storage.get(ACCESS_TOKEN),
        Accept: 'application/json, text/plain, */*' // multipart/form-data
      },
      columns: []
    }
  },
  filters: {},
  created () {
    this.getList()
  },
  computed: {},
  watch: {},
  methods: {
    /** 查询区域信息列表 */
    getList () {
      // this.loading = true
      // districtList(this.queryDisParam).then((response) => {
      //   if (response.code === 200) {
      //     const resData = response.data
      //     this.districtList = resData
      //   }
      //   this.loading = false
      // })
      this.getArea()
    },

     /** **根据系统信息查询区域信息***/
    getArea () {
      this.loading = true
      const param = { pageNum: 1, pageSize: 1 }
      sysList(param).then((response) => {
        if (response.code === 200) {
          const resData_ = response.data
          this.total = resData_.total
          if (this.total > 0) {
            this.list = resData_.records
            this.dataObj = resData_.records[0]
            this.sys = this.dataObj
            this.queryArea.parentId = this.sys.companyCityId
            areaList(this.queryArea).then((res) => {
              if (res.code === 200) {
                const resData = res.data
                const areaList = []
                if (resData != null && resData.length > 0) {
                  for (let i = 0; i < resData.length; i++) {
                    areaList.push({ areaId: resData[i].areaId, areaName: resData[i].areaName, children: [] })
                  }
                  this.districtList = areaList
                }
              }
              this.loading = false
            })
          } else {
            this.queryArea.parentId = ''
            this.$message.error('公司设置所在市信息获取失败')
          }
        }
        this.loading = false
      })
    },

    queryDistrict (queryObj) {
      // 查询区域列表
      this.queryArea = queryObj
      this.getList()
    },

    districtIdHandle (value) {
      this.districtId = value
      this.queryBusinessDisParam.districtId = value
      // 根据区域id查询商圈list
      this.getBusinessDisList()
    },

    getBusinessDisList () {
      this.loading = true
      businessDistrictList(this.queryBusinessDisParam).then((response) => {
        if (response.code === 200) {
          const resData = response.data
          this.businessDisList = resData
        }
        this.loading = false
      })
    },

    queryBusinessDistrict (queryBusinessDisObj) {
      this.queryBusinessDisParam = queryBusinessDisObj
      this.getBusinessDisList()
    },

    getStreetList () {
      this.loading = true
      streetList(this.queryStreetParam).then((response) => {
        if (response.code === 200) {
          const resData = response.data
          this.streetList = resData
        }
        this.loading = false
      })
    },

    queryStreet (queryStreetParamObj) {
      this.queryStreetParam = queryStreetParamObj
      this.getStreetList()
    },

    businessDisIdHandle (value) {
      if (value) {
        this.businessDisId = value
        this.queryStreetParam.businessDistrictId = value
        this.getStreetList()
      } else {
        this.streetList = []
      }
    },

    streetIdHandle (value) {
      this.streetId = value
    }
  }
}
</script>
<style lang="less">
.cur,
.btn_opt {
  background-color: var(--ThemeColor);
}
</style>
<style lang="less" scoped>
@titleFontSize: 20px;
@titleColor: #222;
@bodyFont: 14px;
@bodyColor: #666;
@tagFont: 12px;
@tagColor: #ddd;
.warpper_top,
.warpper_con {
  background: #fff;
  padding: 20px;
}
.warpper_con {
  margin-top: 10px;
  width: 100%;
  justify-content: space-between;
}

.flexWrap {
  flex-wrap: wrap;
}
.warpper_top {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.warpper_top_title {
  font-size: 20px;
  font-weight: bold;
  color: #101010;
}

.ant-form-item {
  width: 20%;
}
.ant-form-item-children {
  display: flex;
  flex-direction: column;
}
.ant-form-item label {
  display: block;
}
.item_page {
  flex: 1;
  border-right: 1px solid #eee;
  /*  box-shadow: -1px 3px 10px #eee;
  -webkit-box-shadow: -1px 3px 10px #eee;
  -moz-box-shadow: -1px 3px 10px #eee;
  -ms-box-shadow: -1px 3px 10px #eee; */
}
</style>
